import type { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { iconEnvelopeOpenText } from '@sorare/core/src/atoms/icons/system/iconEnvelopeOpenText.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { ANY_SPORT_SERIES_INBOX } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { navLabels } from '@sorare/core/src/lib/glossary';

export const InboxButton = ({ children }: PropsWithChildren) => {
  const { formatMessage } = useIntl();
  const { generateSportContextPath } = useSportContext();

  return (
    <ButtonBase
      to={generateSportContextPath(ANY_SPORT_SERIES_INBOX)}
      aria-label={formatMessage(navLabels.inbox)}
    >
      <Horizontal>
        <IconButton
          size="medium"
          icon={iconEnvelopeOpenText}
          color="transparent"
          asSpan
        />
        {children}
      </Horizontal>
    </ButtonBase>
  );
};
